var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1394_41430",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1394_41430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.27083 17.0833C3.84028 17.0833 3.47917 16.9375 3.1875 16.6458C2.89583 16.3542 2.75 16 2.75 15.5833V12.6042H4V15.5833C4 15.6389 4.02778 15.6944 4.08333 15.75C4.13889 15.8055 4.20139 15.8333 4.27083 15.8333H15.7292C15.7986 15.8333 15.8611 15.8055 15.9167 15.75C15.9722 15.6944 16 15.6389 16 15.5833V4.41666C16 4.3611 15.9722 4.30555 15.9167 4.24999C15.8611 4.19443 15.7986 4.16666 15.7292 4.16666H4.27083C4.20139 4.16666 4.13889 4.19443 4.08333 4.24999C4.02778 4.30555 4 4.3611 4 4.41666V7.39582H2.75V4.41666C2.75 3.99999 2.89583 3.64582 3.1875 3.35416C3.47917 3.06249 3.84028 2.91666 4.27083 2.91666H15.7292C16.1597 2.91666 16.5208 3.06249 16.8125 3.35416C17.1042 3.64582 17.25 3.99999 17.25 4.41666V15.5833C17.25 16 17.1042 16.3542 16.8125 16.6458C16.5208 16.9375 16.1597 17.0833 15.7292 17.0833H4.27083ZM8.75 13.7083L7.875 12.8125L10.0625 10.625H2.75V9.37499H10.0625L7.875 7.18749L8.75 6.29166L12.4583 9.99999L8.75 13.7083Z",
    fill: "#252525"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.20105e21defa90f90d4eea251b663cf9.svg";
export { ForwardRef as ReactComponent };